const form = {
  formId: "new-balance-sheet",
  formField: {
    reportingUnit: {
      name: "reportingUnit",
      label: "Đơn vị báo cáo",
      type: "text",
      placeholder: "Soin Media",
      errorMsg: "Vui lòng nhập đơn vị báo cáo",
    },
    address: {
      name: "address",
      label: "Địa chỉ",
      type: "text",
      placeholder: "3/2 Mậu Thân",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    time: {
      name: "time",
      label: "Thời gian",
      type: "number",
      placeholder: "01/01/2000",
      errorMsg: "Vui lòng chọn thời gian",
    },
    type: {
      name: "type",
      label: "Loại",
      type: "text",
      placeholder: "Mẫu số B 01 – DN",
      errorMsg: "Vui lòng chọn loại",
    },
    unit: {
      name: "unit",
      label: "Đơn vị tính",
      type: "text",
      placeholder: "USD",
      errorMsg: "Vui lòng nhập đơn vị",
    },
    total: {
      name: "total",
      label: "Tổng",
      type: "number",
      placeholder: "2000000",
      errorMsg: "Vui lòng nhập tổng",
    },
  },
};

export default form;
